// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Switch = require("../../uikit/reason/atoms/Form/Form__Switch.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let TMPUIKIT____Page = require("../../temporaryUIKit/TMPUIKIT____Page/TMPUIKIT____Page.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let NotificationSettingsBroadcastMessages_notificationSetting_graphql = require("../../__generated__/NotificationSettingsBroadcastMessages_notificationSetting_graphql.bs.js");
let NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql = require("../../__generated__/NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql.bs.js");

let broadcastMessageNotificationPreferenceSettingV5_decode = NotificationSettingsBroadcastMessages_notificationSetting_graphql.Utils.broadcastMessageNotificationPreferenceSettingV5_decode;

let convertFragment = NotificationSettingsBroadcastMessages_notificationSetting_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsBroadcastMessages_notificationSetting_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsBroadcastMessages_notificationSetting_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsBroadcastMessages_notificationSetting_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsBroadcastMessages_notificationSetting_graphql.node, convertFragment, fRef);
}

let NotificationSettingFragment_broadcastMessageNotificationPreferenceSettingV5_fromString = NotificationSettingsBroadcastMessages_notificationSetting_graphql.Utils.broadcastMessageNotificationPreferenceSettingV5_fromString;

let NotificationSettingFragment = {
  broadcastMessageNotificationPreferenceSettingV5_decode: broadcastMessageNotificationPreferenceSettingV5_decode,
  broadcastMessageNotificationPreferenceSettingV5_fromString: NotificationSettingFragment_broadcastMessageNotificationPreferenceSettingV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertVariables;

let convertResponse = NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateUserNotificationSettingsMutation_broadcastMessageNotificationPreferenceSettingV5_decode = NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.broadcastMessageNotificationPreferenceSettingV5_decode;

let UpdateUserNotificationSettingsMutation_broadcastMessageNotificationPreferenceSettingV5_fromString = NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.broadcastMessageNotificationPreferenceSettingV5_fromString;

let UpdateUserNotificationSettingsMutation_entityNotificationPreferenceSettingV5_decode = NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.entityNotificationPreferenceSettingV5_decode;

let UpdateUserNotificationSettingsMutation_entityNotificationPreferenceSettingV5_fromString = NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.entityNotificationPreferenceSettingV5_fromString;

let UpdateUserNotificationSettingsMutation = {
  broadcastMessageNotificationPreferenceSettingV5_decode: UpdateUserNotificationSettingsMutation_broadcastMessageNotificationPreferenceSettingV5_decode,
  broadcastMessageNotificationPreferenceSettingV5_fromString: UpdateUserNotificationSettingsMutation_broadcastMessageNotificationPreferenceSettingV5_fromString,
  entityNotificationPreferenceSettingV5_decode: UpdateUserNotificationSettingsMutation_entityNotificationPreferenceSettingV5_decode,
  entityNotificationPreferenceSettingV5_fromString: UpdateUserNotificationSettingsMutation_entityNotificationPreferenceSettingV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function NotificationSettingsBroadcastMessages(props) {
  let onFailed = props.onFailed;
  let onSuccess = props.onSuccess;
  let notificationSetting = RescriptRelay_Fragment.useFragment(NotificationSettingsBroadcastMessages_notificationSetting_graphql.node, convertFragment, props.notificationSetting);
  let match = use$1();
  let update = match[0];
  let selectedSetting = Stdlib_Option.flatMap(notificationSetting.broadcastMessages, s => broadcastMessageNotificationPreferenceSettingV5_decode(s.setting));
  if (selectedSetting !== undefined) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(TMPUIKIT____Page.Subtitle.make, {
          children: "Message emails"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            "Turn emails on or off for other messages sent on TAN.",
            JsxRuntime.jsx("br", {}),
            "(Services provider recommendations, Need agent in another market, Industry\n                discussion and Miscellaneous)"
          ],
          className: "mb-4"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Form__Switch.make, {
            on: selectedSetting === "ALL_CATEGORIES",
            onToggle: param => {
              let newSetting;
              newSetting = selectedSetting === "ALL_CATEGORIES" ? "NO_CATEGORIES" : "ALL_CATEGORIES";
              update({
                input: {
                  __$inputUnion: "broadcastMessage",
                  _0: newSetting
                }
              }, undefined, {
                updateUserNotificationSettingsV5: {
                  __typename: "UserNotificationSettingsWasUpdated",
                  updatedUserNotificationSettings: {
                    broadcastMessages: {
                      setting: newSetting
                    },
                    nodeId: notificationSetting.nodeId
                  }
                }
              }, undefined, (param, param$1) => {
                let updateUserNotificationSettingsV5 = param.updateUserNotificationSettingsV5;
                if (updateUserNotificationSettingsV5 !== undefined && updateUserNotificationSettingsV5.__typename === "UserNotificationSettingsWasUpdated") {
                  return onSuccess();
                } else {
                  return onFailed();
                }
              }, undefined, undefined);
            }
          }),
          className: "flex"
        })
      ],
      className: "mt-7"
    });
  } else {
    return null;
  }
}

let make = NotificationSettingsBroadcastMessages;

exports.NotificationSettingFragment = NotificationSettingFragment;
exports.UpdateUserNotificationSettingsMutation = UpdateUserNotificationSettingsMutation;
exports.make = make;
/* commitMutation Not a pure module */
